module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/store_images/1@2x_39bda4c8eaa19b93467d6ce0055f8349.png";